export default {
    hasNotif(state) { return state.data.filter(notification => (notification.visualized)).length; },
    loadingToViewNotif(state) { return state.willVisualize.loading; },
    successToViewNotif(state) { return state.willVisualize.success; },
    errorToViewNotif(state) { return state.willVisualize.error; },
    toViewNotif(state) { return state.willVisualize.data; },
};
